import AbsProduct from '@/creditflowresearch/domain/Product/entities/AbsProduct';

export const selectProductIdsForAbsRoute = (): string[] => {
  return [AbsProduct.PRODUCT_ID];
};
